import React, { useEffect, useState } from "react";
import { Button, Col, FloatingLabel, FormControl, Modal, Row, Spinner } from "react-bootstrap";
import PrivateApi from "../../services/PrivateApiService";
import { FaCheckCircle } from "react-icons/fa";
import { MdError } from "react-icons/md";
import { useQueryClient } from "react-query";
import EmployeeStage from "./new_anlage/EmployeeStage";
import { useAuthState } from "../../context/AuthContext";
import CommonUtils from "../../utils/common";


/**
 * RegisterExistingAnlage
 * 
 * used for registering, unregistering selected anlage.
 * Register or unregister is determined with elv array
 * passed to component. If array is empty that means 
 * that there are no running ELV and only option is to
 * regirester.
 * 
 * @param {param} show bool for showing/hidding modal
 * @param {param} setShow setter for bool showing/hidding modal
 * @param {param} anlage object anlage which should be registered/unregistered
 * @param {param} elv array of object if exist anlage should be unregistered
 * @param {param} lastSwitch string of switch element id
 * 
 * @returns Modal
 */
const RegisterExistingAnlageModal = ({show, setShow, anlage, elv, lastSwitch, noContact}) => {

    const API = new PrivateApi();
    const UTILS = new CommonUtils();
    const queryClient = useQueryClient();
    const { contactPerson, user } = useAuthState();
    const [stage, setStage] = useState("default");

    const [registerDate, setRegisterDate] = useState("");
    const [zaehlerstand1, setZaehlerstand1] = useState("");
    const [zaehlerstand2, setZaehlerstand2] = useState("");
    const [reason, setReason] = useState("");
    const [comment, setComment] = useState("");
    const [fieldErors, setFieldErrors] = useState({});

    const dateLimit = new Date();
    dateLimit.setDate(dateLimit.getDate() + 14);

    const greaterDate = (date, dateLimit) => {
        // Create new Date objects without time for the input date
        const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      
        // Create new Date object without time for the dateLimit
        const newDateLimit = new Date(dateLimit.getFullYear(), dateLimit.getMonth(), dateLimit.getDate());
      
        // Compare the dates
        if (newDate.getTime() > newDateLimit.getTime()) {
          return true
        } else {
          return false;
        }
      }


    // effect for setting data by show to default
    useEffect(() => {
        if (show) {
            if (contactPerson || noContact) {
                setStage("default");
            } else {
                setStage('contact');
            }
            setRegisterDate("");
            setZaehlerstand1("");
            setZaehlerstand2("");
            setReason("");
            setComment("");
            setFieldErrors({});
        }
    }, [show])

    

    const greaterOrEqualDate = (date, dateLimit) => {
        // Create new Date objects without time for the input date
        const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      
        // Create new Date object without time for the dateLimit
        const newDateLimit = new Date(dateLimit.getFullYear(), dateLimit.getMonth(), dateLimit.getDate());
      
        // Compare the dates
        if (newDate.getTime() >= newDateLimit.getTime()) {
          return true
        } else {
          return false;
        }
      }


    // handler to send data to backend - create new ticket
    const sendDataHandler = () => {
        var contact = user;
        if (noContact === undefined) contact = contactPerson;
        setStage("loading");
        var data = {
            register_date: registerDate, 
            zaehlerstand1: zaehlerstand1,
            zaehlerstand2: zaehlerstand2,
            comment: comment, 
            reason: reason, 
            anlage: anlage,
            contact: contact,
        };
        if (elv && elv.length > 0) {
            data.register = false;
            if (elv[0].x_is_leerstand) data.leerstand = true
        } else {
            data.register = true;
        }
        API.hw_Anlagen_register(data)
            .then(() => {
                setStage("success");
                queryClient.invalidateQueries("GET_ALL_BUILDING_INFO_QUERY");
                queryClient.invalidateQueries("CLIENT_GET_ANLAGEN");
            })
            .catch(() => {
                setStage("error");
            })
    }

    // handler when next button is pressed to check fields
    // before moving to next stage
    const nextHandler = () => {
        var nextStage = "";
        var temp = {};
        if (stage === "default") {
            nextStage = "question";
            if (registerDate === "") temp.registerDate = true;
            if (anlage.x_is_smartmeter_01 === false && greaterOrEqualDate(new Date(registerDate), dateLimit) === false && zaehlerstand1 === "") temp.zaehlerstand1 = true;
            if (anlage.x_is_smartmeter_01 === false && greaterOrEqualDate(new Date(registerDate), dateLimit) === false &&  isNaN(zaehlerstand1)) temp.zaehlerstand1 = true;
            if (anlage.x_is_smartmeter_01 === false && greaterOrEqualDate(new Date(registerDate), dateLimit) === false && anlage.x_zaehlernummer_02 !== "" && zaehlerstand2 === "") temp.zaehlerstand2 = true;
            if (anlage.x_is_smartmeter_01 === false && greaterOrEqualDate(new Date(registerDate), dateLimit) === false && anlage.x_zaehlernummer_02 !== "" &&  isNaN(zaehlerstand2)) temp.zaehlerstand2 = true;
            if (elv !== undefined && elv.length > 0 && elv[0].x_is_leerstand === false && reason === "") temp.reason = true;
        }
        if (Object.keys(temp).length > 0) return setFieldErrors(temp);
        
        return setStage(nextStage);
    }


    // handler for closing modal
    const closeHandler = () => {
        if (lastSwitch !== "") {
            var switchElem = document.getElementById(lastSwitch);
            if (switchElem) {
                switchElem.checked = !switchElem.checked;
            }
        }
        setShow(false);
    }


    return (
        <Modal show={show} >
            <Modal.Header closeButton onHide={() => closeHandler()}>
                <Modal.Title>
                    {elv && elv.length > 0? "Anlage abmelden":"Anlage anmelden"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    stage === 'contact'?
                        <EmployeeStage setStage={setStage} setShow={setShow} /> :

                    stage === "default"?
                        <>  
                            {anlage?
                                <Row className="mt-3">
                                    <Col>
                                        <p>Anlagenadresse  &nbsp; <small className="text-muted">{anlage.x_adresse_kompakt}</small></p>
                                        <p>Anlagennummer ENERGO &nbsp; <small className="text-muted">{anlage.x_studio_field_mWMGR}</small></p>
                                        <p>Zählernummer  &nbsp; <small className="text-muted">{anlage.x_zaehlernummer_01}</small></p>
                                        <p>Zählpunktnummer  &nbsp; <small className="text-muted">{anlage.x_zaehlpunktnummer_01}</small></p>
                                        {UTILS.notOdooFalseOrEmpty(anlage.x_zaehlpunktnummer_02) &&
                                            <>
                                                <p>Zählernummer 2 &nbsp; <small className="text-muted">{anlage.x_zaehlernummer_02}</small></p>
                                                <p>Zählpunktnummer 2  &nbsp; <small className="text-muted">{anlage.x_zaehlpunktnummer_02}</small></p>
                                            </>
                                        }
                                    </Col>
                                </Row>
                            :null} 
                            <Row className="mt-3">
                                <Col xl="12">
                                    <FloatingLabel label={elv && elv.length > 0? "Anlage abmelden am":"Anlage anmelden am"}>
                                        <FormControl
                                            type="date"
                                            value={registerDate}
                                            onChange={e => {setRegisterDate(e.target.value); setFieldErrors({})}}
                                            placeholder={elv && elv.length > 0? "Anlage abmelden am":"Anlage anmelden am"}
                                            isValid={registerDate !== ""}
                                            isInvalid={fieldErors.registerDate}
                                        />
                                    </FloatingLabel>
                                </Col>
                                { 
                                    greaterDate(new Date, new Date(registerDate))?
                                        <Col xl="12">
                                            <p>
                                                Das {elv && elv.length > 0? "Abmeldedatum":"Anmeldedatum"} liegt in der Vergangenheit. Die 
                                                {elv && elv.length > 0? " Abmeldung":" Anmeldung"} wird in Abstimmung mit dem Energielieferanten am frühest 
                                                möglichen Zeitpunkt durchgeführt.
                                            </p>
                                        </Col> 
                                :null}
                            </Row>
                            
                            <Row className="mt-3">
                                <Col xl={UTILS.notOdooFalseOrEmpty(anlage.x_zaehlernummer_02)? "6":"12"}>
                                    <FloatingLabel label="Zählerstand">
                                        <FormControl 
                                            value={zaehlerstand1}
                                            onChange={e => {setZaehlerstand1(e.target.value); setFieldErrors({})}}
                                            placeholder="Zählerstand" 
                                            isValid={zaehlerstand1 !== "" && !isNaN(zaehlerstand1)}
                                            isInvalid={fieldErors.zaehlerstand1}
                                        />
                                    </FloatingLabel>
                                </Col>
                                <Col xl="6" hidden={!UTILS.notOdooFalseOrEmpty(anlage.x_zaehlernummer_02)}>
                                    <FloatingLabel label="Zweiter Zählerstand">
                                        <FormControl 
                                            value={zaehlerstand2}
                                            onChange={e => {setZaehlerstand2(e.target.value); setFieldErrors({})}}
                                            placeholder="Zweiter Zählerstand"
                                            isValid={zaehlerstand2 !== "" && !isNaN(zaehlerstand2)}
                                            isInvalid={fieldErors.zaehlerstand2}
                                        />
                                    </FloatingLabel>
                                </Col>
                            </Row>
                            <Row className="mt-4" hidden={!greaterOrEqualDate(new Date(registerDate), dateLimit) || registerDate === ""}>
                                <Col xs="12">
                                    <p>Anmeldung mehr als 14 Tage in der Zukunft! Bitte geben Sie die Zählerstände der Anlage rechtzeitig zum Anmeldedatum bei ENERGO bekannt.</p>
                                </Col>
                            </Row>
                            {elv && elv.length > 0 && elv[0].x_is_leerstand === false?
                                <Row className="mt-3">
                                    <Col xl="12">
                                        <FloatingLabel label="Grund der Abmeldung">
                                            <FormControl
                                                value={reason}
                                                onChange={e => {setReason(e.target.value); setFieldErrors({})}}
                                                as="textarea"
                                                style={{height: "100px"}}
                                                isValid={reason !== ""}
                                                isInvalid={fieldErors.reason}
                                            />
                                        </FloatingLabel>
                                    </Col>
                                </Row>
                                :null
                            }
                            <Row className="mt-3">
                                <Col xl="12">
                                    <FloatingLabel label="Zusatzinformation">
                                        <FormControl
                                            as="textarea"
                                            value={comment}
                                            onChange={e => setComment(e.target.value)}
                                            style={{height: "100px"}}
                                        />
                                    </FloatingLabel>
                                </Col>
                            </Row>
                        </> : 
                    stage === "question" ?
                        <Row className="mt-3">
                            <Col xl="12">
                                {elv && elv.length > 0?
                                    elv[0].x_is_leerstand?
                                    <p>Sind Sie sicher, dass Sie den Leerstand mit {new Date(registerDate).toLocaleDateString('DE-de')} abmelden wollen?</p>
                                    :
                                    <p>Sind Sie sicher, dass Sie die Anlage mit {new Date(registerDate).toLocaleDateString('DE-de')} abmelden wollen?</p>
                            :
                                <p>Sind Sie sicher, dass Sie die Anlage mit {new Date(registerDate).toLocaleDateString('DE-de')} anmelden wollen?</p>
                                }
                            </Col>
                        </Row> :
                    
                    stage === "loading" ?
                        <Row>
                            <Col xl="12" className="text-center">
                                <h5>Daten werden übermittelt...</h5>
                                <Spinner animation="grow" className="text-energo" /> &nbsp;
                                <Spinner animation="grow" className="text-energo" /> &nbsp;
                                <Spinner animation="grow" className="text-energo" /> 
                            </Col>
                        </Row>: 

                    stage === "success" ?
                        <Row>
                            <Col xl="12" className="text-center">
                                <h5 className="text-energo">Daten übermittelt</h5>
                                <FaCheckCircle size={50} className="mt-3 text-energo" />
                                <p className="mt-4">Anlagendaten wurden an ENERGO gesendet und werden in Kürze verarbeitet.</p>
                            </Col>
                        </Row> :
                    
                    stage === "error" ?
                        <Row>
                            <Col xl="12" className="text-center">
                                <h5 className="text-danger">Fehler aufgetreten</h5>
                                <MdError size={50} className="text-danger mt-3" />
                                <p className="mt-4">Bei der Übermittlung des Auftrags ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Support, wenn der Fehler erneut auftritt.</p>
                            </Col>
                        </Row>
                    :null
                }
            </Modal.Body>
            <Modal.Footer>
                {
                    stage === "default"? 
                        <Button onClick={() => nextHandler()} className="btn-energo">Weiter</Button> :

                    stage === "question"?
                        <>
                            <Button onClick={() => setStage("default")} variant="warning">Abbrechen</Button>
                            <Button onClick={() => sendDataHandler()} className="btn-energo">Ja, ich bin sicher</Button>
                        </>:

                    stage === "success" ?
                        <Button onClick={() => setShow(false)} className="btn-energo">Schließen</Button> : 
                    
                    stage === "error" ? 
                        <>
                            <Button onClick={() => setShow(false)} variant="warning">Schließen</Button>
                            <Button onClick={() => sendDataHandler()} className="btn-energo">Erneut versuchen</Button>
                        </>
                    :null
                }
            </Modal.Footer>
        </Modal>
    )
}
export default RegisterExistingAnlageModal;